export default {
      id: "icon-angle-left-white-usage",
      viewBox: "0 0 8 14",
      url: __webpack_public_path__ + "icons.svg#icon-angle-left-white",
      toString: function () {
        return this.url;
      }
    }